import React from 'react';

const TipoIcon = ({tipo}) =>
{
    switch(tipo.trim())
    {
       case "Tarjeta Debito":
         return <span className="ti-credit-card"></span>;

       case "PIN -Debito":
         return <span className="ti-pin-alt"></span>;
  
       default:
         return null;
    }
}


export default TipoIcon;
